var BpamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../application/view-application/view-application-routing.constants";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ViewApplicationDetailsBpComponent } from "../../../application/view-application/modules/bp/view-application-details-bp/view-application-details-bp.component";
import { ViewApplicationLocationBpComponent } from "../../../application/view-application/modules/bp/view-application-location-bp/view-application-location-bp.component";
import { ViewApplicationProfessionalBodiesBpComponent } from "../../../application/view-application/modules/bp/view-application-professional-bodies-bp/view-application-professional-bodies-bp.component";
import { CreateApplicationDetailsBpComponent } from "../../../application/create-application/modules/bp/create-application-details-bp/create-application-details-bp.component";
import { CreateApplicationLocationBpComponent } from "../../../application/create-application/modules/bp/create-application-location-bp/create-application-location-bp.component";
import { CreateApplicationProfessionalBodiesBpComponent } from "../../../application/create-application/modules/bp/create-application-professional-bodies-bp/create-application-professional-bodies-bp.component";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ApiBuildingPlansConstants } from "../../constants/api-constants/api-building-plans.constants";
import { SearchOwnerInfoComponent } from "../../../tabs/applications/application-search/search-owner-info/search-owner-info.component";
import { SearchPropertyInfoBpamsComponent } from "../../../tabs/applications/application-search/modules/bp/search-property-info-bpams/search-property-info-bpams.component";
import { ObjectUtils } from "../../utils/object-utils";
import RecipientUtils from "../../utils/recipient-utils";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { SearchBuildingUseComponent } from "../../../tabs/applications/application-search/search-building-use/search-building-use.component";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var BpamsSearchOptions;
(function (BpamsSearchOptions) {
    BpamsSearchOptions["ReferenceNumber"] = "Reference Number";
    BpamsSearchOptions["MyApplications"] = "My Applications";
    BpamsSearchOptions["ApplicantAgent"] = "Applicant Agent";
    BpamsSearchOptions["ApplicantInfo"] = "Applicant Information";
    BpamsSearchOptions["AppID"] = "Application ID";
    BpamsSearchOptions["ApplicationStatus"] = "Application Status";
    BpamsSearchOptions["ApplicationCategory"] = "Application Category";
    BpamsSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    BpamsSearchOptions["AssignedToUsers"] = "Assigned to";
    BpamsSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    BpamsSearchOptions["CreatedDate"] = "Created Date";
    BpamsSearchOptions["CreatedDateRange"] = "Created Date Range";
    BpamsSearchOptions["StartDate"] = "Started Date";
    BpamsSearchOptions["StartDateRange"] = "Started Date Range";
    BpamsSearchOptions["DaysUntilExpired"] = "Days until Expired";
    BpamsSearchOptions["OwnerInfo"] = "Owner Information";
    BpamsSearchOptions["PercentageComplete"] = "Percentage Complete";
    BpamsSearchOptions["PropertyInfo"] = "Property Information";
    BpamsSearchOptions["TimeoutStatus"] = "Timeout Status";
    BpamsSearchOptions["BuildingUse"] = "Building Use";
    BpamsSearchOptions["JobID"] = "Job ID";
})(BpamsSearchOptions || (BpamsSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["Sector"] = "Sector";
    ApplicationHeadingEnum["IsRDP"] = "Is RDP";
    ApplicationHeadingEnum["BuildingUse"] = "Building Use";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([[ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"], [ApplicationHeadingEnum.ErfNumber, "erfNumbers"], [ApplicationHeadingEnum.ApplicationType, "applicationType"], [ApplicationHeadingEnum.Applicant, "applicant"], [ApplicationHeadingEnum.Agent, "agent"], [ApplicationHeadingEnum.Sector, "sector"], [ApplicationHeadingEnum.IsRDP, "isRDP"], [ApplicationHeadingEnum.BuildingUse, "buildingUse"], [ApplicationHeadingEnum.StartDate, "startDate"], [ApplicationHeadingEnum.ApplicationStatus, "phase"], [ApplicationHeadingEnum.DaysLeft, "daysLeft"], [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"], [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],]);
// TODO: remove commented out sections?
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["FarmNumber"] = "Farm Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.FarmNumber, "farmNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const BpamsSearchQueryLookup = new Map([
    [BpamsSearchOptions.AppID, "appId"],
    [BpamsSearchOptions.ReferenceNumber, "referenceNumber"],
    [BpamsSearchOptions.JobID, "jobId"]
]);
export const BpamsAdditionalSearchOptions = [BpamsSearchOptions.MyApplications, BpamsSearchOptions.AssignedToUsers, BpamsSearchOptions.UnassignedApplications, BpamsSearchOptions.ApplicationsWithoutStartDate];
export const BpamsDateSearchOptions = new Map([[BpamsSearchOptions.StartDate, 1], [BpamsSearchOptions.StartDateRange, 2],]);
export const BpamsStartDateRangeSearchOptions = new Map([[BpamsSearchOptions.CreatedDate, 1], [BpamsSearchOptions.CreatedDateRange, 2],]);
export const BpamsStatusSearchOptions = new Map([[BpamsSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS], [BpamsSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE], [BpamsSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [BpamsSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS]
]);
export const BpamsBuildingUseSearchOptions = new Map([
    [BpamsSearchOptions.BuildingUse, ApplicationSearchConstants.BUILDING_USE],
]);
export const BpamsSearchOptionClientHeight = new Map([[BpamsSearchOptions.ReferenceNumber, SearchContainerHeight.Simple], [BpamsSearchOptions.MyApplications, SearchContainerHeight.Simple], [BpamsSearchOptions.AppID, SearchContainerHeight.Simple], [BpamsSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine], [BpamsSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine], [BpamsSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine], [BpamsSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine], [BpamsSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine], [BpamsSearchOptions.CreatedDate, SearchContainerHeight.SingleLine], [BpamsSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine], [BpamsSearchOptions.ApplicantAgent, SearchContainerHeight.Extended], [BpamsSearchOptions.ApplicantInfo, SearchContainerHeight.Extended], [BpamsSearchOptions.OwnerInfo, SearchContainerHeight.Extended], [BpamsSearchOptions.PropertyInfo, SearchContainerHeight.Max]]);
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var BpamsSearchOptionTableListEnum;
(function (BpamsSearchOptionTableListEnum) {
    BpamsSearchOptionTableListEnum["Application"] = "BP_APPLICATION|Application";
    BpamsSearchOptionTableListEnum["Property"] = "BP_APPLICATIONPROPERTY|Properties";
    BpamsSearchOptionTableListEnum["PropertyBuildings"] = "BP_APPLICATIONPROPERTYBUILDING|PropertyBuildings";
    BpamsSearchOptionTableListEnum["Zoning"] = "BP_APPLICATIONPROPERTYZONING|PropertyZonings";
    BpamsSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    BpamsSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    BpamsSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
    BpamsSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owners";
})(BpamsSearchOptionTableListEnum || (BpamsSearchOptionTableListEnum = {}));
export const BPExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_BP;
export const BPTableNameListForSearchOptions = BpamsSearchOptionTableListEnum.Application + "," + BpamsSearchOptionTableListEnum.Property + "," + BpamsSearchOptionTableListEnum.PropertyBuildings + "," + BpamsSearchOptionTableListEnum.Zoning + "," + BpamsSearchOptionTableListEnum.Status + "," + BpamsSearchOptionTableListEnum.Applicant + "," + BpamsSearchOptionTableListEnum.ApplicantAgent + "," + BpamsSearchOptionTableListEnum.Owner;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const BpRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let BpamsStrategyService = class BpamsStrategyService extends AflaModuleStrategyService {
    static { BpamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.BuildingPlans;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    buildingUseSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable;
    applicationServiceUrl = ApiBuildingPlansConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = BPExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = BPExpandListForApplicationSearch;
    searchOptionTableNameList = BPTableNameListForSearchOptions;
    customApplicationTableColumnMap;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Property help",
        "Application help",
        "Agent help",
        "Professional bodies help",
        "Required documentation help",
        "Notes help",
        "Applicant help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    setApplicantAndApplicantAgentAction = ApiBuildingPlansConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps;
    stampOptions = [{ name: "Building plan number", expand: "", attribute: "buildingPlanNumber" }];
    previousApplication = null;
    postApplicationSubscription;
    statusColumn = "status/ workflowSection";
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.BUILDING_PLANS_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Properties"];
        this.requiredMapFields = BpRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, BPExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = BpamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = BpamsSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = BpamsAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(BpamsSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(BpamsSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = BpamsDateSearchOptions;
        this.RangeSearchOptions = BpamsStartDateRangeSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = BpamsStatusSearchOptions;
        this.clientHeightMap = BpamsSearchOptionClientHeight;
    }
    initializeBuildingUseSearchOptions() {
        this.buildingUseSearchOptions = BpamsBuildingUseSearchOptions;
        this.clientHeightMap = BpamsSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: BpamsStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
            farmNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "farmNumber"),
            applicationType: application.applicationType,
            applicant: BpamsStrategyService_1.getRecipientName(BpamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: BpamsStrategyService_1.getRecipientName(BpamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
            sector: application.sector,
            isRDP: application.isRdp,
            buildingUse: application.buildingUse
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "properties":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // 3rd level tables
        const propertyDetails = [ApplicationSearchConstants.OWNERS, ApplicationSearchConstants.PROPERTY_BUILDINGS, ApplicationSearchConstants.PROPERTY_ZONINGS];
        if (!fieldValue && propertyDetails.indexOf(appGroup.toLowerCase()) > -1) {
            if (application.properties.length > 0) {
                application.properties.forEach((property) => {
                    for (const [propkey, propVal] of Object.entries(property)) {
                        if (propkey.toLowerCase() === appGroup.toLowerCase() || (propkey.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS) && appGroup.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS)) || (propkey.toLowerCase().endsWith(ApplicationSearchConstants.BUILDINGS) && appGroup.toLowerCase().endsWith(ApplicationSearchConstants.BUILDINGS))) {
                            propVal.forEach((value) => {
                                for (const [groupKey, groupValue] of Object.entries(value)) {
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size) || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(BpamsSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([[ViewApplicationMenuHeadings.Details, ViewApplicationDetailsBpComponent,], [ViewApplicationMenuHeadings.ProfessionalBodies, ViewApplicationProfessionalBodiesBpComponent,], [ViewApplicationMenuHeadings.Location, ViewApplicationLocationBpComponent,]]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationMenuHeadings.Details, CreateApplicationDetailsBpComponent],
            [CreateApplicationMenuHeadings.ProfessionalBodies, CreateApplicationProfessionalBodiesBpComponent],
            [CreateApplicationMenuHeadings.Location, CreateApplicationLocationBpComponent,]
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [BpamsSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [BpamsSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [BpamsSearchOptions.BuildingUse, SearchBuildingUseComponent],
            [BpamsSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [BpamsSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [BpamsSearchOptions.StartDate, SearchStartDateComponent],
            [BpamsSearchOptions.StartDateRange, SearchStartDateComponent],
            [BpamsSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [BpamsSearchOptions.PercentageComplete, SearchStatusComponent],
            [BpamsSearchOptions.ApplicationStatus, SearchStatusComponent],
            [BpamsSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [BpamsSearchOptions.TimeoutStatus, SearchStatusComponent],
            [BpamsSearchOptions.DaysUntilExpired, SearchStatusComponent],
            [BpamsSearchOptions.OwnerInfo, SearchOwnerInfoComponent],
            [BpamsSearchOptions.PropertyInfo, SearchPropertyInfoBpamsComponent]
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID, useCompleteListForSearch) {
        let params = BpamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), BpamsStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = BpamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, BpamsStrategyService_1.buildModuleIDFilter(moduleID), BpamsStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchByDays(moduleID, daysFilter) {
        let params = BpamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        if (daysFilter === SharedConstants.DASHBOARD_FILTERS.OverdueApplications)
            params = params.append("$filter", `status/daysUntilExpired le 0 and moduleId eq ${moduleID} `);
        else if (daysFilter === SharedConstants.DASHBOARD_FILTERS.LatestApplications)
            params = params.append("$filter", `status/daysUntilExpired gt 0 and status/daysUntilExpired lt ${SharedConstants.DAYS_LIMIT} and moduleId eq ${moduleID} `);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateBPAMSApplication");
        const application = this.buildApplication();
        this.postApplicationSubscription = this.postApplicationService(application).subscribe({
            next: (savedApplication) => {
                this.appController.showMessage(BpamsStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                this.resetForm();
                this.requestStatusService.removeBusySpinner("CreateBPAMSApplication");
                this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]);
            }, error: (error) => {
                this.requestStatusService.removeBusySpinner("CreateBPAMSApplication");
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
            }
        });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape, properties",
            $expand: "properties",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
        this.form.get("noteForm").get("notes").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiBuildingPlansConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, properties($expand=owners), lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID) {
        const params = {
            invoiceId: invoiceID
        };
        return this.http.get(`${ApiBuildingPlansConstants.URL}/${applicationId}/${ApiBuildingPlansConstants.FUNCTION_GET_GENERATE_INVOICE}`, {
            responseType: "blob",
            params
        });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiBuildingPlansConstants.URL}/${applicationId}/${ApiBuildingPlansConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        const params = {
            jobId,
            category
        };
        return this.http.get(`${ApiBuildingPlansConstants.URL}/${moduleId}/${ApiBuildingPlansConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null), notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                isMinorBuildingWork: new FormControl(null, [Validators.required]),
                isResidential: new FormControl(null, [Validators.required]),
                buildingType: new FormControl(""),
                isBuildingUseOther: new FormControl(false, [Validators.required]),
                isAlterations: new FormControl(null, [Validators.required]),
                buildingPlanNumber: new FormControl({ value: null, disabled: true }),
                sector: new FormControl(null, [Validators.required]),
                isRDP: new FormControl(null, [Validators.required]),
                buildingUse: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                applicationEstimatedBy: new FormControl(null, [Validators.required]),
                applicationEstimatedCost: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null),
                isResubmission: new FormControl(null),
                previousReferenceNumber: new FormControl(null),
            }),
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
            }),
            professionalBodiesForm: new FormGroup({
                sacapRegistrationNumber: new FormControl(null),
                architectRecipient: new FormControl(null),
                engineerRecipients: new FormControl(null),
                electricalContractorRecipient: new FormControl(null),
                fireConsultantRecipient: new FormControl(null),
                otherProfessionalRecipient: new FormControl(null),
                markArchitectAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToArchitect: new FormControl(null),
                markEngineerAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToEngineer: new FormControl(null),
                markElectricalContractorAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToElectricalContractor: new FormControl(null),
                markFireConsultantAsNotApplicable: new FormControl(null),
                markOtherProfessionalAsNotApplicable: new FormControl(null),
                copyApplicantDetailsToFireConsultant: new FormControl(null),
                copyApplicantDetailsToOtherProfessional: new FormControl(null)
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form
                .get("applicantForm")
                .get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        let architectRecipient = null;
        const architectFormControl = this.form.get("professionalBodiesForm").get("architectRecipient");
        const copyApplicantDetailsToArchitect = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToArchitect").value;
        const markArchitectAsNotApplicable = this.form.get("professionalBodiesForm").get("markArchitectAsNotApplicable").value;
        if (copyApplicantDetailsToArchitect) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, architectFormControl, true);
        }
        if (copyApplicantDetailsToArchitect === true || markArchitectAsNotApplicable === true) {
            const architectRecipientFormValue = architectFormControl.value;
            architectRecipient = RecipientUtils.removeRecipientProperties(architectRecipientFormValue);
        }
        let engineerRecipient = null;
        const engineerRecipientsFormControl = this.form.get("professionalBodiesForm").get("engineerRecipients");
        const copyApplicantDetailsToEngineer = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToEngineer").value;
        const markEngineerAsNotApplicable = this.form.get("professionalBodiesForm").get("markEngineerAsNotApplicable").value;
        if (copyApplicantDetailsToEngineer) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, engineerRecipientsFormControl, true);
        }
        if (copyApplicantDetailsToEngineer === true || markEngineerAsNotApplicable === true) {
            const engineerRecipientsFormValue = engineerRecipientsFormControl.value;
            engineerRecipient = RecipientUtils.removeRecipientProperties(engineerRecipientsFormValue);
        }
        let electricalContractorRecipient = null;
        const electricalContractorRecipientFormControl = this.form.get("professionalBodiesForm").get("electricalContractorRecipient");
        const copyApplicantDetailsToElectricalContractor = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToElectricalContractor").value;
        const markElectricalContractorAsNotApplicable = this.form.get("professionalBodiesForm").get("markElectricalContractorAsNotApplicable").value;
        if (copyApplicantDetailsToElectricalContractor) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, electricalContractorRecipientFormControl);
        }
        if (copyApplicantDetailsToElectricalContractor === true || markElectricalContractorAsNotApplicable === true) {
            const electricalContractorRecipientFormValue = electricalContractorRecipientFormControl.value;
            electricalContractorRecipient = RecipientUtils.removeRecipientProperties(electricalContractorRecipientFormValue);
        }
        const isResubmissionSelection = this.form.get("detailsForm").get("isResubmission").value;
        let markForResubmission = false;
        if (isResubmissionSelection === SharedConstants.YES_NO_ENUM.Yes) {
            markForResubmission = true;
        }
        else {
            markForResubmission = false;
        }
        // Fire Consultant
        let fireConsultantRecipient = null;
        const fireConsultantRecipientFormControl = this.form.get("professionalBodiesForm").get("fireConsultantRecipient");
        const copyApplicantDetailsToFireConsultant = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToFireConsultant").value;
        const markFireConsultantAsNotApplicable = this.form.get("professionalBodiesForm").get("markFireConsultantAsNotApplicable").value;
        if (copyApplicantDetailsToFireConsultant) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, fireConsultantRecipientFormControl);
        }
        if (copyApplicantDetailsToFireConsultant === true || markFireConsultantAsNotApplicable === true) {
            const fireConsultantRecipientFormValue = fireConsultantRecipientFormControl.value;
            fireConsultantRecipient = RecipientUtils.removeRecipientProperties(fireConsultantRecipientFormValue);
        }
        // Other Professional
        let otherProfessionalRecipient = null;
        const otherProfessionalRecipientFormControl = this.form.get("professionalBodiesForm").get("otherProfessionalRecipient");
        const copyApplicantDetailsToOtherProfessional = this.form.get("professionalBodiesForm").get("copyApplicantDetailsToOtherProfessional").value;
        const markOtherProfessionalAsNotApplicable = this.form.get("professionalBodiesForm").get("markOtherProfessionalAsNotApplicable").value;
        if (copyApplicantDetailsToOtherProfessional) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, otherProfessionalRecipientFormControl);
        }
        if (copyApplicantDetailsToOtherProfessional === true || markOtherProfessionalAsNotApplicable === true) {
            const otherProfessionalRecipientFormValue = otherProfessionalRecipientFormControl.value;
            otherProfessionalRecipient = RecipientUtils.removeRecipientProperties(otherProfessionalRecipientFormValue);
        }
        const application = {
            decision: "",
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            isResubmission: markForResubmission,
            previousReferenceNumber: this.form.get("detailsForm").get("previousReferenceNumber").value,
            description: this.form.get("detailsForm").get("description").value,
            isMinorBuildingWork: this.form.get("detailsForm").get("isMinorBuildingWork").value,
            isResidential: this.form.get("detailsForm").get("isResidential").value,
            buildingType: this.form.get("detailsForm").get("buildingType").value,
            isBuildingUseOther: this.form.get("detailsForm").get("isBuildingUseOther").value,
            isAlterations: this.form.get("detailsForm").get("isAlterations").value,
            sector: this.form.get("detailsForm").get("sector").value.value,
            isRdp: this.form.get("detailsForm").get("isRDP").value,
            buildingUse: this.form.get("detailsForm").get("buildingUse").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value.value,
            applicationEstimatedBy: this.form.get("detailsForm").get("applicationEstimatedBy").value.value,
            applicationEstimatedCost: this.form.get("detailsForm").get("applicationEstimatedCost").value,
            shape: "",
            wkid: 102100,
            applicant: [applicant],
            applicantAgent: [],
            architect: [],
            engineer: [],
            electricalContractor: [],
            fireConsultant: [],
            otherProfessional: [],
            notes: [],
            properties: [],
            applicantAgentNa: !markApplicantAgentAsNotApplicable,
            architectNa: !markArchitectAsNotApplicable,
            engineerNa: !markEngineerAsNotApplicable,
            electricalContractorNa: !markElectricalContractorAsNotApplicable,
            fireConsultantNa: !markFireConsultantAsNotApplicable,
            otherProfessionalNa: !markOtherProfessionalAsNotApplicable
        };
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent.push(applicantAgent);
        }
        if (copyApplicantDetailsToArchitect === true || markArchitectAsNotApplicable === true) {
            application.architect.push(architectRecipient);
        }
        if (copyApplicantDetailsToEngineer === true || markEngineerAsNotApplicable === true) {
            application.engineer.push(engineerRecipient);
        }
        if (copyApplicantDetailsToElectricalContractor === true || markElectricalContractorAsNotApplicable === true) {
            application.electricalContractor.push(electricalContractorRecipient);
        }
        if (copyApplicantDetailsToFireConsultant === true || markFireConsultantAsNotApplicable === true) {
            application.fireConsultant.push(fireConsultantRecipient);
        }
        if (copyApplicantDetailsToOtherProfessional === true || markOtherProfessionalAsNotApplicable === true) {
            application.otherProfessional.push(otherProfessionalRecipient);
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const owners = item.get("owners").value.recipients;
            owners.forEach((owner) => {
                owner = RecipientUtils.removeRecipientProperties(owner);
            });
            const property = {
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                erfSize: parseFloat(item.get("erfSize").value),
                farmNumber: item.get("farmNo").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                titleDeed: item.get("titleDeed").value,
                updateGeometry: false,
                wkid: 102100,
                applicationDescription: item.get("propertyDescription").value,
                applicationRestrictions: item.get("titleDeedRestrictions").value,
                externalWalls: item.get("externalWalls").value.value,
                internalWalls: item.get("internalWalls").value.value,
                roofing: item.get("roofing").value.value,
                numberOfHouses: item.get("numberOfHousesUnits").value,
                patioCoveredExisting: item.get("coveredExisting").value,
                patioCoveredAdded: item.get("coveredAdded").value,
                patioOpenExisting: item.get("openExisting").value,
                patioOpenAdded: item.get("openAdded").value,
                pool: item.get("pool").value,
                boundaryWallHeight: item.get("boundaryWallHeight").value,
                boundaryWallRunning: item.get("boundaryWallRunning").value,
                coverage: item.get("coverage").value,
                bulkCalculation: item.get("bulkCalculation").value,
                zonings: [],
                buildings: [],
                owners,
            };
            // mainBuildings: new FormArray([], [Validators.min(1)]),
            const mainBuildingsArray = item.get("mainBuildings");
            mainBuildingsArray.controls.forEach((mainBuilding) => {
                const building = {
                    deleted: false,
                    type: "Main Building",
                    floor: mainBuilding.get("floor").value.toString(),
                    existingSize: mainBuilding.get("existingSize").value,
                    addedSize: mainBuilding.get("addedSize").value
                };
                property.buildings.push(building);
            });
            const outBuildingsArray = item.get("outBuildings");
            outBuildingsArray.controls.forEach((outBuilding) => {
                const building = {
                    deleted: false,
                    type: "Additional Building",
                    floor: outBuilding.get("floor").value.toString(),
                    existingSize: outBuilding.get("existingSize").value,
                    addedSize: outBuilding.get("addedSize").value
                };
                property.buildings.push(building);
            });
            const propertyZonesArray = item.get("zones");
            propertyZonesArray.controls.forEach((zoneItem) => {
                const zone = {
                    deleted: false, zoning: zoneItem?.get("zone")?.value?.value,
                };
                property.zonings.push(zone);
            });
            application.properties.push(property);
        });
        const shape = `MULTIPOINT (${points.join(", ")})`;
        application.shape = shape;
        return application;
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService }
    ];
};
BpamsStrategyService = BpamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], BpamsStrategyService);
export { BpamsStrategyService };
